const data = require(`./data_${process.env.REACT_APP_BUILD_UID}/localization.json`)
const localization = {...data}

export default localization